import { get, put, post } from "./httpClient";
import { Period, PeriodsData } from "../../types/period";

export async function getPeriods(
  site: string,
  year: number
): Promise<PeriodsData> {
  try {
    return await get<PeriodsData>(`/sites/${site}/periods/${year}`, { cacheResponse: 30 });
  } catch (error: any) {
    // Return default structure if no periods exist or if error
    if (error.status === 404 || error.status === 403) {
      return {
        year,
        site,
        periods: [],
        lastUpdated: new Date().toISOString(),
      };
    }
    throw error;
  }
}

export async function savePeriods(
  site: string,
  year: number,
  periods: Period[]
): Promise<PeriodsData> {
  const periodsData: PeriodsData = {
    year,
    site,
    periods,
    lastUpdated: new Date().toISOString(),
  };

  return put<PeriodsData>(`/sites/${site}/periods/${year}`, periodsData, { cacheResponse: false });
}

export async function resetToDefaultPeriods(
  site: string,
  year: number
): Promise<PeriodsData> {
  return post<PeriodsData>(`/sites/${site}/periods/${year}/reset`, {}, { cacheResponse: false });
}